import { render } from "./AccountDetailsModal.vue?vue&type=template&id=ab21649a&scoped=true"
import script from "./AccountDetailsModal.vue?vue&type=script&lang=js"
export * from "./AccountDetailsModal.vue?vue&type=script&lang=js"

import "./AccountDetailsModal.vue?vue&type=style&index=0&id=ab21649a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab21649a"]])

export default __exports__